import { render, staticRenderFns } from "./CauseList.vue?vue&type=template&id=42177ed9"
import script from "./CauseList.vue?vue&type=script&lang=js"
export * from "./CauseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports